<template>
  <el-row>
    <el-col :span="24">
      <el-date-picker  style="width:100%" v-validate="item.isRequired  ?'required': ''" :name="item.id" :class="errors.has(item.id) ? 'is-error':''"  v-model="value" type="date" :placeholder="item.body.placeholder">
      </el-date-picker>
    </el-col>
  </el-row>
</template>
<script>
export default {
  data() {
    return {
      value: ''
    }
  },
  inject: ['parentValidator'],
  methods: {
    sendDataSurvey(data) {
      var _this = this
      _this.$store.commit('editSurvey', data)
    }
  },
  watch: {
    value: function(val) {
      var _this = this
      _this.sendDataSurvey({ surveyDetailId: _this.item.id, values: [_this.value] })
    }
  },
  created() {
    var _this = this;
    this.$validator = this.parentValidator
  },
  props: ['item']
}
</script>

